export default __webpack_public_path__ + "1096486d81939029e6694e3ff909c96a.png";